// @flow
/* eslint-env browser */

import { defineCustomElement } from '../../define-custom-element';
import { LIB_VERSION } from '../../version';
import { DisplayAdComponent } from './component';

window.localStorage.setItem('quick-rewards-display-version', `quick-rewards/${LIB_VERSION}`);
defineCustomElement(DisplayAdComponent);
